import CardUserHorizontal from "./card-user-horizontal";

export default CardUserHorizontal;